import React, {useEffect, useMemo, useState} from "react";
import {Link, useParams} from 'react-router-dom';
import {storage} from "../../firebase.config";
import FullPageLoader from '../../utils/loader';
import {useSelector} from 'react-redux';
import {ref,getDownloadURL,listAll,getMetadata,deleteObject} from "firebase/storage"
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import uniqBy from 'lodash/uniqBy'

const DateWise = (props) => {
    const [isLoading,setLoading] = useState(false);
    const [isDeleting,setIsDeleting] = useState(false);
    const { username,date, folderPath } = useParams();
    const [imageList, setImageList] = useState([]);
    const [videoList, setVideoList] = useState([]);
    const [videoFolder, setVideoFolder] = useState(null)
    const sortBy  = useSelector((state) => state.changeOrder)
    const path = useMemo(() => {
        return `${username}/${date}/${folderPath || ''}`
    }, [username, date, folderPath])
    const ascending = (a, b) => {
        const numA = parseInt(a.img_name.match(/\d+/)[0], 10);
        const numB = parseInt(b.img_name.match(/\d+/)[0], 10);

        if (numA < numB) {
        return -1;
        }
        if (numA > numB) {
        return 1;
        }
    }

    const descending = (a, b) => {
        const numA = parseInt(a.img_name.match(/\d+/)[0], 10);
        const numB = parseInt(b.img_name.match(/\d+/)[0], 10);
        // console.log(numA)
        return numB - numA;
    }
  
    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;
        const listAllFoldersDateWise = async () => {
            try {
                setLoading(true)
                const userRef = ref(storage, path);
                const items = await listAll(userRef);
                const videoIndex = items.prefixes.findIndex((prefix) => prefix.name === 'videos')
                const filtered = [...items.prefixes]
                // console.log({filtered})
                // if(folderPath) filtered.splice(videoIndex, 1);
                setVideoFolder(items.prefixes[videoIndex] || null)
                setLoading(false)
                for (const lot of filtered) {
                    if (signal.aborted)  return; // Stop the loop if the component is unmounted
                    const lotContent = await listAll(lot);
                    // Add each image to the allImages ar
                    for (const file of lotContent.items) {
                        if (signal.aborted)  return; // Stop the loop if the component is unmounted
                        const meta = await getMetadata(file)
                        if(file.parent.fullPath.includes('videos')) {
                            const temp = {
                                video_url: await getDownloadURL(file),
                                path: meta.fullPath,
                                video_name: meta.fullPath.split("/").pop(),
                                last_modify: meta.updated
                            }
                            setVideoList((prev) => uniqBy([...prev,temp], 'video_name'))
                        } else {
                            const temp = { "img_url": await getDownloadURL(file),"img_name":meta.fullPath.split("/").pop(),last_modify:meta.updated }
                            setImageList((prev) => uniqBy([...prev,temp],'img_name'))
                        }
                    }
                }
            } catch (error) {
                setLoading(false)
                console.error('Error listing folders:', error.message);
            }
        };
        listAllFoldersDateWise();
        return () => {
            abortController.abort();
        };
    },[path, folderPath]);
    async function deleteFolder() {
        setIsDeleting(true)
        const dateRef = ref(storage, videoFolder.fullPath);
        const lotResult = await listAll(dateRef);
        for (const lotFolder of lotResult.prefixes) {
            const lotResult = await listAll(lotFolder);
            for (const subItem of lotResult.items) {
                await deleteObject(subItem);
            }
        }
        setIsDeleting(false)
    }
    const deleteImage = (user) => {
            const imageRef = ref(storage, `/${username}/${date}/${user.img_name.split("-")[0]}/${user.img_name}`);
            deleteObject(imageRef).then((res) => setImageList((prev)=>prev.filter((name)=>name.img_name !== user.img_name)));
    };
    const deleteVideo = (item) => {
            const fileRef = ref(storage, item.path);
            deleteObject(fileRef).then((res) => setVideoList((prev)=>prev.filter((name)=>name.video_name !== item.video_name)));
    };
    const deleteAlert  = (e, asset, func) => {
        e.preventDefault();
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                <div className='custom-ui'>
                    <h1>Delete {asset}</h1>
                    <p>Are you sure you want to delete this {asset}?</p>
                    <button onClick={onClose}>No</button>
                    <button onClick={() => { func(); onClose(); }} >
                        Yes, Delete it!
                    </button>
                </div>
                );
            }
            });
      };

    return(
        <div className="container-fluid height-74">
            { isLoading  &&  <FullPageLoader/> }

            <div className="row">
                {
                    videoFolder && <Link to={`/${username}/${date}/videos`} className="col-xl-2 col-md-6 mb-4 text-decoration-none">
                        <div className="card border-left-primary shadow h-100 py-2">
                            <div className="card-body" style={{padding: "10px"}}>
                                <img src={require("../../img/folder1.png")}  alt="folder-icon" />
                                <div className="text-xs font-weight-bold text-primary text-capitalize mb-1">Videos</div>
                            </div>
                            <div className="delete-container" onClick={(e)=> deleteAlert(e,'folder', deleteFolder)} >
                                {
                                    isDeleting ?
                                        <div className="loader"/> :
                                        <div className="delete-div">
                                            <img src={require("../../img/trash.png")}  alt="trash-icon" />
                                        </div>
                                }
                            </div>
                        </div>

                    </Link>
                }
                {
                    !folderPath && !!imageList.length &&
                        // imageList.sort(sortBy === 'ascending' ? ascending : descending ).map((item, index) =>  (
                            imageList.map((item, index) =>  (
                                    <div  className="col-xl-2 col-md-6 mb-4" key={index}>
                                        <div className="card border-left-primary shadow h-100 py-2">
                                            <div className="card-body" style={{padding: "10px"}}>
                                                <Zoom>
                                                    <img  src={item.img_url} className="main-pic" alt="folder-icon" width="500"  />
                                                </Zoom>
                                                <div className="text-xs font-weight-bold text-primary text-uppercase pt-2"> {item.img_name.split("/").pop()}</div>
                                            </div>
                                            <div className="delete-container" onClick={(event)=> deleteAlert(event, 'Image', () => deleteImage(item))}>
                                                <div className="delete-div">
                                                    <img src={require("../../img/trash.png")}  alt="trash-icon" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) 
                            )
                }
                {
                    folderPath && !!videoList.length &&
                    // imageList.sort(sortBy === 'ascending' ? ascending : descending ).map((item, index) =>  (
                    videoList.map((item, index) =>  (
                            <div  className="col-xl-2 col-md-6 mb-4" key={index}>
                                <div className="card border-left-primary shadow h-100 py-2">
                                    <div className="card-body" style={{padding: "10px"}}>
                                        <video
                                            src={item.video_url}
                                            controls
                                            style={{ width: "100%", height: '200px' }}
                                        />
                                        <div className="text-xs font-weight-bold text-primary text-uppercase pt-2"> {item.video_name.split("/").pop()}</div>
                                    </div>
                                    <div className="delete-container" onClick={(event)=> deleteAlert(event, 'Video', () => deleteVideo(item))}>
                                        <div className="delete-div">
                                            <img src={require("../../img/trash.png")}  alt="trash-icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    )
                }
            </div>
            {
                (!imageList.length && !videoList.length && !videoFolder) && !isLoading &&
                    <div  className="no-data-center">
                            <div className="no-data-center-font"> No Data </div>
                    </div>
            }
        </div>
    );
}

export default DateWise;